<template>
  <div class="footer z-flex z-flex-center">
    <!-- <img class="logo" src="../assets/images/logo.png"/> -->
    <div class="copyright">©2019 福州全摄汇网络科技有限公司版权所有<br>闽ICP备19009816号-2 </div>
  </div>
</template>

<script>
export default {
  name: "footerCom",
  props: {
    
  },
  data() {
    return {
      
    };
  },
  mounted() {
    
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.footer{
  margin: 0 60px;
  padding: 40px 0;
  .logo{
    height:30px;
  }
  .copyright{
    color: #777;
    line-height: 1.8;
    text-align: center;
  }
}
</style>
